<template>
    <Select v-model="selected">
        <option 
            v-for="timezone in timezones" 
            :value="timezone.id" 
            :key="timezone.id" 
        >
            {{ timezone.label }}
        </option>
    </Select>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import { listTimeZones } from 'timezone-support/lookup-convert';
import Select from '@/components/ui/forms/Select.vue';

export default {
    name: "TimezonePicker",
    components: { Select },
    props: {
        value: {
            type: String
        }
    },
    data: () => ({
        selected: null,
        timezones: []
    }),
    created: function () {
        const baseTz = listTimeZones();
        const now = moment();
        const formattedTz = [];
        baseTz.forEach(timezoneName => {
            const diffInMinute = now.tz(timezoneName).utcOffset();
            formattedTz.push({
                id: timezoneName,
                label: `(UTC${this.parseMinutes(diffInMinute)}) ${timezoneName}`,
                diff: diffInMinute
            });
        });
        formattedTz.sort((a, b) => {
            return a.diff - b.diff;
        });
        this.timezones = formattedTz;
        this.selected = this.value;
    },
    methods: {
        parseMinutes: (minutes) => {
            const sign = minutes >= 0 ? "+" : "-";
            const hours = Math.abs(minutes / 60 | 0).toString().padStart(2, "0");
            const mins = Math.abs(minutes % 60 | 0).toString().padStart(2, "0");
            return `${sign}${hours}:${mins}`;
        }
    },
    watch: {
        selected: function (newVal) {
            this.$emit("input", newVal);
        }
    },
}
</script>
